<script>
    import { onMount } from 'svelte';
    import { user } from './sessionStore';
    import { supabase } from './supabaseClient';
    import router from 'page';

    onMount(() => {
        const unsubscribe = user.subscribe($user => {
            if ($user) {
                // User is authenticated, redirect to /myboards/
                console.log('Signed In.')
                router.redirect('/myboards/');
            }
        });

        return () => {
            // Cleanup the subscription when the component is destroyed
            unsubscribe();
        };
    });
</script>

<div>Signing In..</div>